import { createContext, useContext } from 'react';

import type { CustomTestsSearchContextValue } from 'pages/custom_tests/components/custom_tests_search/CustomTestsSearch';

export const CustomTestsSearchContext = createContext({} as CustomTestsSearchContextValue);
CustomTestsSearchContext.displayName = 'CustomTestsSearchContext';

export const useCustomTestsSearch = () => useContext(CustomTestsSearchContext);